import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    ReferenceLine,
    Legend,
    Label,
} from 'recharts';
import clsx from 'clsx';
import styles from '../Graph.module.scss';

import { isMobile } from '../../../../../utils/utils';
// import { lineStaticData as staticData } from '../../../../../utils/staticGraphData';
// import { graphDataType } from '../../../../../store/Dashboard/types';
// import { GRAPH_NAMES } from '../../../../../store/Dashboard/constants';
import CustomTooltip from './CustomTooltip/CustomTooltip';
import { formatPeriod } from '../../../../../store/dashboard/transformer';
import { useEffect, useState } from 'react';
import { GRAPH_NAMES } from '../../../../../store/dashboard/constants';
import { CHART_NAMES } from '../../../../../store/dashboard/creditBureau/constants';

/**
 * @Description Line graph component for single value for every x-coordinate
 */

interface LineGraphProps {
    height: number;
    error: boolean;
    graphData: any;
    graphName: string;
}

function LineGraph(props: LineGraphProps) {
    const { error, graphName } = props;
    const { colors, hasNegative, plots, metadata } = props.graphData;
    const graphData = plots[0]?.plotValues || [];
    const [linesExists, setLineExists] = useState({
        secondLineExists: false,
        thirdLineExists: false,
        fourthLineExists: false,
    });

    useEffect(() => {
        if (metadata?.legend) {
            const secondLineExists = 'yValue2' in metadata?.legend;
            const thirdLineExists = 'yValue3' in metadata?.legend;
            const fourthLineExists = 'yValue4' in metadata?.legend;
            setLineExists({
                secondLineExists,
                thirdLineExists,
                fourthLineExists,
            });
        }
    }, [metadata?.legend]);

    return (
        <ResponsiveContainer width="100%" height={props.height}>
            <LineChart
                data={graphData.length ? graphData : []}
                margin={{
                    top: 30,
                    right: 20,
                    left: -25,
                    bottom: 0,
                }}
                className={clsx({ [styles.DisabledGraphSvg]: error })}
            >
                <XAxis
                    dataKey="xValue"
                    tick={{ fontSize: '10px' }}
                    axisLine={{ stroke: hasNegative ? '#ffffff' : '#000000' }}
                    tickFormatter={(val) => formatPeriod(val)}
                    interval={0}
                />
                {metadata?.legend ? (
                    <Legend
                        verticalAlign="top"
                        align="right"
                        wrapperStyle={{ fontSize: isMobile ? '10px' : '14px', top: 0, right: 10 }}
                        iconType="circle"
                        formatter={(value, entry, index) => {
                            return metadata?.legend?.[value];
                        }}
                    />
                ) : null}
                <YAxis
                    tick={{ fontSize: '9px' }}
                    axisLine={{ stroke: '#ffffff' }}
                    tickLine={false}
                    dx={0}
                    // label={{ value: 'Index', angle: -90, }}

                    // tickFormatter={addYaxisLabel}
                >
                    {!!metadata?.yTitle && (
                        <Label
                            dy={-20}
                            value={metadata?.yTitle}
                            offset={0}
                            angle={-90}
                            style={{ fontSize: '12px', fill: '#BCBCBC' }}
                        />
                    )}
                </YAxis>
                {hasNegative ? <ReferenceLine y={0} stroke="#000000" /> : <></>}
                {/* <Legend
                    verticalAlign="top"
                    height={30}
                    align="right"
                    wrapperStyle={{
                        fontSize: isMobile ? '10px' : '14px',
                        width: '100%',
                        top: 20,
                        left: -10,
                    }}
                    iconType="circle"
                    // payload={}
                    formatter={(v) => {
                        return legend?.[v];
                    }}
                /> */}
                <Tooltip
                    content={
                        <CustomTooltip graphName={props.graphName} graphData={props.graphData} />
                    }
                    wrapperStyle={{ outline: 'none' }}
                    cursor={{ fill: 'transparent' }}
                />
                <Line
                    type="monotone"
                    dataKey={'yValue'}
                    stroke={error ? colors?.error.secondary : colors?.primary}
                    dot={{ fill: colors?.primary }}
                    activeDot={{ fill: 'white', stroke: 'black' }}
                    strokeWidth={3}
                />
                {linesExists.secondLineExists && (
                    <Line
                        type="monotone"
                        dataKey={'yValue2'}
                        stroke={colors?.secondary}
                        dot={{ fill: colors?.secondary }}
                        activeDot={{ fill: 'white', stroke: 'black' }}
                        strokeWidth={3}
                    />
                )}
                {linesExists.thirdLineExists && (
                    <Line
                        type="monotone"
                        dataKey={'yValue3'}
                        stroke={colors?.tertiary}
                        dot={{ fill: colors?.tertiary }}
                        activeDot={{ fill: 'white', stroke: 'black' }}
                        strokeWidth={3}
                    />
                )}

                {linesExists.fourthLineExists && (
                    <Line
                        type="monotone"
                        dataKey={'yValue4'}
                        stroke={colors?.fourth}
                        dot={{ fill: colors?.fourth }}
                        activeDot={{ fill: 'white', stroke: 'black' }}
                        strokeWidth={3}
                    />
                )}
            </LineChart>
        </ResponsiveContainer>
    );
}

export default LineGraph;
